define((require) => {
    "use strict";

    const $                 = require("jquery");
    const EventDispatcher   = require("shared/util/EventDispatcher");
    const {isBlank}         = require("shared/util/StringUtils");
    const LoggedIn          = require("shared/security/LoggedIn");
    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");

    const REPLACE_REG_EXP     = new RegExp("/", "g");
    const DEFAULT_CLASS_NAMES = "dashboard";
    const LOGGED_IN           = " logged-in";
    const LOGGED_OUT          = " logged-out";

    /**
     * Contains logic for adding the current route name as a CSS class name to the
     * &#60;html&#62; root element, replacing "/" with a whitespace.
     *
     * @class CSSHistoryManager
     */
    return EventDispatcher.extend({

        _history: null,

        _classNames: DEFAULT_CLASS_NAMES,

        _htmlRootElement: null,

        /**
         * Constructor.
         *
         * @constructor
         * @param {Backbone.history} history The Backbone history instance.
         */
        constructor(history) {
            this._history = history;
            this._htmlRootElement = $("html");
        },

        /**
         * Invoked when the route changes.
         */
        _routeChangedHandler: function CSSHistoryManagerStartRouteChangedHandler() {
            this._updateToHistoryState();
        },

        /**
         * Updates the CSS class name of the &#60;html&#62; root element.
         */
        _updateToHistoryState: function CSSHistoryManagerUpdateToHistoryState() {
            this._htmlRootElement.removeClass(this._classNames);
            this._classNames = this._history.fragment.replace(REPLACE_REG_EXP, " ");

            // Special handing when we're at the dashboard (no route name)
            if (isBlank(this._classNames)) {
                this._classNames = DEFAULT_CLASS_NAMES;
            }

            this._classNames += LoggedIn.principal() ? LOGGED_IN : LOGGED_OUT;

            this._htmlRootElement.addClass(this._classNames);
        },

        /**
         * Starts listening for route changes.
         */
        start: function CSSHistoryManagerStart() {
            this.listenTo(this._history, "route", this._routeChangedHandler);
            this.listenTo(LoggedInUserState, "change:ready", this._routeChangedHandler);

            this._updateToHistoryState();
        }

    }, {
        injection: ["history"]
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/CSSHistoryManager.js